export default "__VITE_ASSET__BYbtJ4j___"